import React, { useState } from "react";
import { AutoComplete, Button, Col, Form, Input, notification, Row } from "antd";

import styles from "./styles.less";
import { CloudUploadOutlined } from "@ant-design/icons/lib";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestSel, BacktestType } from "@/features/backtest";
import { AppSel } from "@/features/applications";
import { FireSel, FireType } from "@/features/firestore";
import { firebaseDb } from "@/infrastructure/firebase";
import moment from "moment";

const { TextArea } = Input;

export default () => {
  const setup = useRootSelector(BacktestSel.setup);
  const result = useRootSelector(BacktestSel.result);
  const userId = useRootSelector(AppSel.userId);
  const username = useRootSelector(AppSel.username);
  const [isLoading, setIsLoading] = useState(false);
  const tags = [
    ...new Set(
      useRootSelector(FireSel.backtestSnapshot)
        .filter(e => e)
        .map(e => e.tag)
    )
  ].map(e => ({ value: e }));

  return (
    <Form onFinish={uploadTemplate} layout={"vertical"}>
      <Form.Item
        label={"Name"}
        name={"name"}
        rules={[{ required: true, message: "Please enter a name for your snapshot." }]}
      >
        <Input className={styles.input} placeholder={"Enter name here"} />
      </Form.Item>
      <Form.Item
        label={"Description"}
        name={"desc"}
        rules={[{ required: true, message: "Please provide a brief description about your snapshot." }]}
      >
        <TextArea
          className={styles.input}
          placeholder={"Enter description here"}
          autoSize={{ minRows: 1, maxRows: 6 }}
        />
      </Form.Item>
      <Row justify={"space-between"}>
        <Col span={18}>
          <Form.Item label={"Tag"} name={"tag"} rules={[{ required: true, message: "Please tag your snapshot" }]}>
            <AutoComplete className={styles.input} placeholder={"Enter tag here"} options={tags} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item>
            <Button icon={<CloudUploadOutlined />} htmlType={"submit"} className={styles.submitBtn} loading={isLoading}>
              Upload
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );

  function uploadTemplate(input: any) {
    const data: FireType.BacktestSnapshot = {
      userId: userId,
      name: input.name,
      description: input.desc,
      author: username,
      date: moment().format("L"),
      tag: input.tag,
      setup,
      // historical data should not be saved to firebase due to large size
      results: {
        initialCash: result.initialCash,
        featureImportance: result.featureImportance,
        groupResult: Object.entries(result.groupResult).reduce(
          (a, [k, v]) => ({
            ...a,
            [k]: removeHistoricalData(v)
          }),
          {} as BacktestType.GroupResult
        ),
        singleResult: result.singleResult.map(e => ({
          ...e,
          results: removeHistoricalData(e.results)
        })) as BacktestType.SingleResult[]
      }
    };
    setIsLoading(true);
    firebaseDb
      .collection("backtest_snapshot")
      .doc(`${userId}_${input.name}`)
      .set(data)
      .then(() => {
        setIsLoading(false);
        notification.success({
          message: `Snapshot: ${input.name} uploaded successfully!`
        });
      });
  }

  function removeHistoricalData<T>(btResult?: BacktestType.BacktestResult) {
    return btResult
      ? {
          ...btResult,
          portfolioHistoricalValues: [],
          ohlcWithIndicators: [],
          portfolioCummulativeReturn: [],
          portfolioRollingVolatility: [],
          portfolioRollingSharpe: []
        }
      : {};
  }
};
